import { LiveChannel$Details, LiveChannel } from '../types/Live';

import BaseRepository, { PagedListResponse } from '@/repositories/base-repository';

type LR = PagedListResponse<LiveChannel>;

export default class LiveChannelsRepository extends BaseRepository<LiveChannel$Details, never, LR> {
  constructor() {
    super('/live/channel');
  }

  public uploadSplash(file: File, channelId: string) {
    return this._upload(file, `${channelId}/splash`);
  }

  public async removeSplash(channelId: string) {
    return this.undo(channelId, 'splash');
  }

  public uploadBanner(file: File, channelId: string) {
    return this._upload(file, `${channelId}/banner`);
  }

  public async removeBanner(channelId: string) {
    return this.undo(channelId, 'banner');
  }

  public uploadLogo(file: File, channelId: string) {
    return this._upload(file, `${channelId}/logo`);
  }

  public async removeLogo(channelId: string) {
    return this.undo(channelId, 'logo');
  }
}
